module.exports = __webpack_public_path__ + "static/media/CE.8607a4ea.jpg";